<template>
  <LoadingWithText v-if="isLoading" />
  <div v-else>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <PageHeader class="text-lg font-medium mr-auto" />
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <Button
          type="button"
          :to="{ name: 'LoansActive' }"
          class="box text-gray-700 dark:text-gray-300 flex"
        >
          {{ $t('text.back') }}
        </Button>
      </div>
    </div>
    <LoanDetailsHeader :loan="loan" class="intro-y mt-5" />
    <div class="intro-y mt-5">
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 lg:col-span-6">
          <LoanDetailsMain :loan="loan" />
        </div>
        <div class="col-span-12 lg:col-span-6">
          <LoanDetailsHistory :loan="loan" />
          <LoanDetailsNotes :loan="loan" class="mt-5" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LOAN_REQUEST } from '@/store/actions/loan';
import PageHeader from '@/components/ui/PageHeader';
import Button from '@/components/ui/button/Button';
import LoanDetailsHeader from '@/components/loan/LoanDetailsHeader';
import LoanDetailsMain from '@/components/loan/LoanDetailsMain';
import LoanDetailsHistory from '@/components/loan/LoanDetailsHistory';
import LoanDetailsNotes from '@/components/loan/LoanDetailsNotes';

export default {
  components: {
    PageHeader,
    Button,
    LoanDetailsHeader,
    LoanDetailsMain,
    LoanDetailsHistory,
    LoanDetailsNotes,
  },

  computed: {
    ...mapGetters(['loan', 'loanStatus']),
    isLoading() {
      return this.loanStatus === 'loading';
    },
  },

  watch: {
    '$route.params.loanId': 'fetchData',
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      try {
        await this.$store.dispatch(LOAN_REQUEST, this.$route.params.loanId);
      } catch (error) {
        this.$toasted.show(this.$t('toast.failedRoute'), { type: 'error' });
        this.$router.push({ name: 'Loans' });
      }
    },
  },
};
</script>
